<div class="circles">
  <li></li>
  <li></li>
  <li></li>
  <li></li>
</div>

<div class="infoForMouse"></div>
<div class="infoForZoom"></div>

<h1 class="SEO">Skills - Rahil Hastu</h1>
<section class="home-main-section skills-main-section">
  <div class="title skillssection">
    <p class="upskill">&lt;skill&gt;</p>
    <p class="uph1skill">&lt;h1&gt;</p>
    <div class="skill">
      <span>S</span>
      <span>K</span>
      <span>I</span>
      <span>L</span>
      <span>L</span>
      <span>S</span>
    </div>
    <p class="downh1skill">&lt;/h1&gt;</p>

    <div class="description">
      <p>
        As a software and application development expert with 3 years of
        industry experience and a current pursuit of a master's degree, I bring
        a versatile skill set and a passion for creating exceptional digital
        solutions. With a strong foundation in backend development using C++,
        Python and a proficiency in crafting engaging user interfaces with React
        and Angular , I offer a comprehensive approach to software
        development.<br />

        My expertise extends beyond Python and React to include Java, and
        JavaScript, along with frameworks like Django and Angular JS. I am
        well-versed in database management, having worked with MongoDB, SQLite,
        and MySQL.<br />

        Utilizing Agile methodologies, CI/CD practices, and following the
        Software Development Life Cycle (SDLC), I ensure efficient and
        high-quality development processes. I am adept at version control using
        Git and possess expertise in containerization and deployment through
        Docker and Kubernetes.<br />

        Driven by a commitment to staying updated with the latest industry
        trends and technologies, I thrive in collaborative environments where I
        contribute my skills to innovative projects.<br />

        If you're seeking a dedicated software and application developer with a
        diverse technical skill set, look no further. Let's collaborate to bring
        your ideas to life!<br />
      </p>
      <!-- <p>Although I have been in the IT industry for about a year, all throughout
      my undergraduate in college I was involved in a variety of projects,
      hackathons, etc. I have a knack towards anything to do with Front-end
      development.</p>
      <p class="hide-for-mobile"> My current techstack involves C++ for backend development and Angular JS for frontend development. I have
      previously worked with Python, C, Java, JavaScript and frameworks including Django and Angular. I am comfortable with Databases including Mongo, SQLite and MySql.
    </p>
    <p>I like to code things from scratch, and enjoy bringing ideas to life in the browser. Fueled by high energy levels and boundless enthusiasm, I’m easily inspired and more then willing to follow my fascinations wherever they take me.</p> -->
    </div>
    <p class="downskill">&lt;/skill&gt;</p>
  </div>

  <div class="bigR">
    <div id="myCanvasContainer">
      <canvas width="300" height="300" id="myCanvas">
        <p>
          Anything in here will be replaced on browsers that support the canvas
          element
        </p>
      </canvas>
    </div>
    <div id="tags">
      <ul>
        <li><a routerLink="/skills">React</a></li>
        <li><a routerLink="/skills">Kubernetes</a></li>
        <li><a routerLink="/skills">Docker</a></li>
        <li><a routerLink="/skills">Django</a></li>
        <li><a routerLink="/skills">Python</a></li>
        <li><a routerLink="/skills">C++</a></li>
        <li><a routerLink="/skills">Angular</a></li>
        <li><a routerLink="/skills">JavaScript</a></li>
        <li><a routerLink="/skills">Java</a></li>
        <li><a routerLink="/skills">GIT</a></li>
        <li><a routerLink="/skills">CSS</a></li>
        <li><a routerLink="/skills">HTML</a></li>
        <li><a routerLink="/skills">Figma</a></li>
        <li><a routerLink="/skills">Mongo</a></li>
        <li><a routerLink="/skills">SQLite</a></li>
        <li><a routerLink="/skills">SQL</a></li>
        <li><a routerLink="/skills">Heroku</a></li>
        <li><a routerLink="/skills">AWS</a></li>
        <li><a routerLink="/skills">Hadoop</a></li>
        <li><a routerLink="/skills">Apache Spark</a></li>
        <li><a routerLink="/skills">Docker</a></li>
        <li><a routerLink="/skills">JSON</a></li>
        <li><a routerLink="/skills">Postgres</a></li>
        <li><a routerLink="/skills">CI/CD</a></li>
      </ul>
      #"
    </div>
    #"
  </div>
</section>
